// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "InfoSection-module--wrapper--I+Eb8";
export var container = "InfoSection-module--container--pgt1D";
export var heading = "InfoSection-module--heading--+B8J5";
export var number = "InfoSection-module--number--B5poK";